import { render } from "./AsExternalDocument.vue?vue&type=template&id=6edfa730&ts=true"
import script from "./AsExternalDocument.vue?vue&type=script&lang=ts"
export * from "./AsExternalDocument.vue?vue&type=script&lang=ts"

import "./AsExternalDocument.vue?vue&type=style&index=0&id=6edfa730&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__